import React, { useEffect } from 'react';
import styled from 'styled-components';
import ImgThemed from '@/components/ImgThemed/ImgThemed';
import { useSelector } from 'react-redux';
import { RootState } from '@/reduxStore/rootReducer';
import ArrowRight from '@/assets/icons/arrow-right.svg';
import ArrowRightDark from '@/assets/icons/arrow-right-dark.svg';
import TransactionInfoRow from '@/components/TransactionInfoRow/TransactionInfoRow';
import { Button } from '@monavate/ui-core';

const TransactionRowContainer = styled.div`
    border-bottom: 1px solid ${(props) => props.theme['Borders/quiet']};
    color: ${(props) => props.theme['Content/primary']};
    height: 68px;
    align-items: center;
    padding: 4px 12px 4px 32px;
    display: flex;
`;

const ButtonContainer = styled.div`
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;

    & button {
        height: 32px;
        width: 32px;
        padding: 4px;
    }
`;

interface RelatedTransactionsProps {
    setRelatedTransaction: (transaction: any) => void;
}

const RelatedTransactions: React.FC<RelatedTransactionsProps> = ({ setRelatedTransaction }) => {
    const relatedTransactionsList = useSelector(
        (state: RootState) => state.transaction.relatedTransactionsList,
    );

    const handleRelatedTransactionClick = (transaction: any) => {
        setRelatedTransaction(transaction);
    };

    return (
        <div>
            {relatedTransactionsList.map((transaction, index) => (
                <TransactionRowContainer key={index}>
                    <TransactionInfoRow transaction={transaction} />
                    <ButtonContainer>
                        <Button
                            hideBorder
                            handleClick={() => handleRelatedTransactionClick(transaction)}
                        >
                            <ImgThemed
                                src={ArrowRight}
                                srcDark={ArrowRightDark}
                                alt="Arrow Right"
                            />
                        </Button>
                    </ButtonContainer>
                </TransactionRowContainer>
            ))}
        </div>
    );
};

export default RelatedTransactions;
